document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-collection')) return;

  const hideSizes = () => {
    document.querySelectorAll('.product-card, .card').forEach(card => {
      // Alle Buttons / Optionen mit Größen-Text entfernen
      card.querySelectorAll('button, li, a').forEach(el => {
        const text = el.textContent.trim().toUpperCase();
        if (['XS','S','M','L','XL','XXL'].includes(text)) {
          el.style.display = 'none';
        }
      });
    });
  };

  hideSizes();

  // Falls JS vom Theme nachlädt (Quickshop)
  const observer = new MutationObserver(hideSizes);
  observer.observe(document.body, { childList: true, subtree: true });
});